// const baseUrl = 'http://192.168.5.83:71/';
const baseUrl = 'http://zs.aigcszcyy.com/';

export function currentUrl() {
    if (process.env.NODE_ENV === 'development') {
        return baseUrl;
    }
    if (process.env.NODE_ENV === 'production') {
        // return location.origin;
        return location.origin;
    }
    return baseUrl;
}

export function getStorage() {
    // 需要先判断是否以斜杠结尾
    if (currentUrl().endsWith('/')) {
        return currentUrl() + 'storage';
    }
    return currentUrl() + '/storage';
}
